window.Vue = require('vue');

Vue.component('header-top-bar', require('./HeaderTopBar.vue'));
Vue.component('section-title', require('./SectionTitle.vue'));
Vue.component('select-car-dropdown', require('./SelectCarDropdown.vue'));
Vue.component('footer-component', require('./Footer.vue'));
Vue.component('insert-plate', require('./InsertPlate.vue'));
Vue.component('license-plate-container', require('./LicensePlateContainer.vue'));
Vue.component('accordion-faq', require('./AccordionFaq.vue'));
Vue.component('section-title-after', require('./SectionTitleAfter.vue'));
Vue.component('car-recap', require('./CarRecap.vue'));
Vue.component('car-notes', require('./CarNotes.vue'));
Vue.component('loader', require('./Loader.vue'));
Vue.component('car-equipment', require('./CarEquipment.vue'));
Vue.component('inquiry', require('./Inquiry.vue'));
Vue.component('hero-box', require('./HeroBox.vue'));
Vue.component('hero-box-sponsor', require('./HeroBoxSponsor.vue'));
Vue.component('hero-box-aci-report', require('./HeroBoxAciReport.vue'));
Vue.component('product-definition', require('./ProductDefinition.vue'));
Vue.component('stepper', require('./Stepper.vue'));
Vue.component('certificate-example', require('./CertificateExample.vue'));
Vue.component('product-explanation', require('./ProductExplanation.vue'));
Vue.component('buy-quotation-btn', require('./BuyQuotationBtn.vue'));
Vue.component('form-field-km', require('./FormFieldKm.vue'));
Vue.component('form-field-average', require('./FormFieldAverage.vue'));
Vue.component('form-field-date', require('./FormFieldDate.vue'));
Vue.component('form-field-add-info', require('./FormFieldAddInfo.vue'));
Vue.component('form-field-property', require('./FormFieldProperty.vue'));
Vue.component('form-fields', require('./FormFields.vue'));
Vue.component('date-filter', require('./DateFilter.vue'));
Vue.component('quotation-container', require('./QuotationContainer.vue'));
Vue.component('disclaimer-section', require('./DisclaimerSection.vue'));
Vue.component('vehicle-icon', require('./VehicleIcon.vue'));
Vue.component('car-filter-container', require('./CarFilterContainer.vue'));
Vue.component('find-equipment', require('./FindEquipment.vue'));
Vue.component('buy-quotation-form', require('./BuyQuotationForm.vue'));
Vue.component('buy-sponsored-form', require('./BuySponsoredForm.vue'));
Vue.component('classic-select-container', require('./ClassicSelectContainer.vue'));
Vue.component('select-classic-dropdown', require('./SelectClassicDropdown.vue'));
Vue.component('sw-alert', require('./SwAlert.vue'));
Vue.component('certificate-default', require('./CertificateDefault.vue'));
Vue.component('certificate-classic', require('./CertificateClassic.vue'));
Vue.component('classic-disclaimer', require('./ClassicDisclaimer.vue'));
Vue.component('tips-tricks', require('./TipsTricks.vue'));
Vue.component('classic-car-data', require('./ClassicCarData.vue'));
Vue.component('custom-select', require('./CustomSelect.vue'));
Vue.component('storic-select-container', require('./StoricSelectContainer.vue'));
Vue.component('select-storic-dropdown', require('./SelectStoricDropdown.vue'));
Vue.component('livemarket-data-container', require('./LivemarketDataContainer.vue'));
Vue.component('classic-car-container', require('./ClassicCarContainer.vue'));
Vue.component('livemarket-data-your-car', require('./LivemarketDataYourCar.vue'));
Vue.component('livemarket-data-overview', require('./LivemarketDataOverview.vue'));
Vue.component('livemarket-data-focus', require('./LivemarketDataFocus.vue'));
Vue.component('livemarket-data-distribution', require('./LivemarketDataDistribution.vue'));
Vue.component('livemarket-data-competitors', require('./LivemarketDataCompetitors.vue'));
Vue.component('livemarket-data-average', require('./LivemarketDataAverage.vue'));
Vue.component('livemarket-data-alternatives', require('./LivemarketDataAlternatives.vue'));
Vue.component('select-commercial-dropdown', require('./SelectCommercialDropdown.vue'));
Vue.component('select-industrial-dropdown', require('./SelectIndustrialDropdown.vue'));
Vue.component('bar-chart-vertical', require('./BarChartVertical.vue'));
Vue.component('bubble-chart', require('./BubbleChart.vue'));
Vue.component('card-product', require('./CardProduct.vue'));



// WEBPACK FOOTER //
// ./resources/js/app/components/vue-declarator.js